var _CourseCardSkeleton;
import { CourseCardSkeleton, GridScroll } from "../../../../../components";
import { jsx as _jsx } from "react/jsx-runtime";
var MainCategoriesContentSkeleton = function MainCategoriesContentSkeleton(_ref) {
  var className = _ref.className;
  var renderCard = function renderCard(_, index) {
    return /*#__PURE__*/_jsx(CourseCardSkeleton, {}, index);
  };
  return /*#__PURE__*/_jsx(GridScroll, {
    items: Array.from({
      length: 3
    }).map(renderCard),
    className: className,
    children: _CourseCardSkeleton || (_CourseCardSkeleton = /*#__PURE__*/_jsx(CourseCardSkeleton, {}))
  });
};
export default MainCategoriesContentSkeleton;